module.exports = __webpack_public_path__ + "img/list.c23fb6e3.svg";